import { createFileRoute } from '@tanstack/react-router';
import NewOrderPage from '../components/manager/NewOrderPage';

export const Route = createFileRoute('/manager/orders/new')({
  validateSearch: (search: Record<string, unknown>) => ({
    accommodationId: typeof search.accommodationId === 'string' ? search.accommodationId : undefined,
    checkIn: typeof search.checkIn === 'string' ? search.checkIn : undefined,
    checkOut: typeof search.checkOut === 'string' ? search.checkOut : undefined,
    from: typeof search.from === 'string' ? search.from : undefined,
  }),
  component: ManagerNewOrderRoute,
});

function ManagerNewOrderRoute() {
  return <NewOrderPage />;
}
